<template>
  <div v-if="discountedPrice" class="flex items-end">
    <UiText :class="priceClass" class="text-neutral-500">
      {{ formatPrice(locale as Locale, discountedPrice.amount, discountedPrice.currency_code) }}
    </UiText>
    <UiText v-if="price" class="ml-3 text-neutral-500 line-through">
      {{ formatPrice(locale as Locale, price.amount, price.currency_code) }}
    </UiText>
  </div>
  <div v-else-if="price">
    <UiText v-if="price" :class="priceClass" class="text-neutral-500">
      {{ formatPrice(locale as Locale, price.amount, price.currency_code) }}
    </UiText>
  </div>
</template>

<script setup lang="ts">
import type { ProductPriceProps } from '~/components/Product/types';

import { useAppStore } from '~/stores/app/appStore';

const { locale } = useI18n();

const appStore = useAppStore();

const props = defineProps<ProductPriceProps>();

const price = computed(() =>
  props.product ? getPrice(props.product, appStore.getCurrentCurrency, props.variantSku) : null,
);

const discountedPrice = computed(() =>
  props.product ? getPrice(props.product, appStore.getCurrentCurrency, props.variantSku, true) : null,
);
</script>
